import React from 'react';
import { useIntl } from 'react-intl';

import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';
import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';

export interface DriverGroupSuccessScreenProps {
  onClose: () => void;
  isEditMode: boolean;
}

export const DriverGroupSuccessScreen = ({ onClose, isEditMode }: DriverGroupSuccessScreenProps) => {
  const intl = useIntl();

  return (
    <WizardScreen footerMode={FooterMode.CREATED} onCancel={onClose}>
      <WizardFinished
        text={
          isEditMode
            ? intl.formatMessage({
                id: 'predict.forecasting.changes_saved',
                defaultMessage: 'Changes saved'
              })
            : intl.formatMessage({
                id: 'common.group_created',
                defaultMessage: 'Group created'
              })
        }
      />
    </WizardScreen>
  );
};
